import { APPLICATION_PATHS } from '../application-core/constants';
import PropTypes from 'prop-types';
import React from 'react';
import ExternalResourceLink from '../core/ExternalResourceLink';
import IriLink from '../core/IriLink';
import OntologyIcon from '../core/icons/Ontology';

class IsDefinedBy extends React.Component {

    render() {

        const { components, id, isDefinedBy, graph, projectIRI } = this.props;

        return (
            <React.Fragment>
                {
                    components.includes(isDefinedBy) ?
                        <IriLink
                            dataTest="isDefinedBy"
                            key={isDefinedBy}
                            iri={isDefinedBy}
                            isReadOnly={true}
                            graph={graph}
                            source={id}
                            property="isDefinedBy"
                            icon={<OntologyIcon fontSize="small" />}
                            link={
                                APPLICATION_PATHS.ONTOLOGY_MANAGER + '/project/ontology#project='
                                + projectIRI + "&ontology=" + isDefinedBy
                            } />
                        :
                        <ExternalResourceLink
                            key={isDefinedBy}
                            id={isDefinedBy}
                            graph={graph}
                            isReadOnly={true}
                            source={id}
                            property="isDefinedBy" />
                }
            </React.Fragment>
        );
    }
}

IsDefinedBy.propTypes = {
    projectIRI: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    isDefinedBy: PropTypes.string.isRequired,
    components: PropTypes.array,
    ontologyIRI: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
};

export default IsDefinedBy;